import { render, staticRenderFns } from "./BlogPostAddUpdate.vue?vue&type=template&id=0d357d06&scoped=true&"
import script from "./BlogPostAddUpdate.vue?vue&type=script&lang=js&"
export * from "./BlogPostAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d357d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d357d06')) {
      api.createRecord('0d357d06', component.options)
    } else {
      api.reload('0d357d06', component.options)
    }
    module.hot.accept("./BlogPostAddUpdate.vue?vue&type=template&id=0d357d06&scoped=true&", function () {
      api.rerender('0d357d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Blog/BlogPostAddUpdate.vue"
export default component.exports